import { palette, body2 } from '@/modules/defines/styles';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import arrowLeft from '@/assets/icon/arrow-left-wh.svg';
import ArrowBigRight from '@/assets/icon/minimap/ArrowBigRight';
interface TopNavigationProps {
  depTitle: string | undefined;
  arrTitle: string | undefined;
}

const TopNavigation = ({ depTitle, arrTitle }: TopNavigationProps) => {
  return (
    <Wrapper>
      <ArrowLeft
        onClick={() => sessionStorage.removeItem('xr-navi-point')}
        to="/navi"
      >
        <img src={arrowLeft} alt="뒤로가기" />
      </ArrowLeft>
      <PointBox>
        <Point>{depTitle}</Point>
        <li>
          <ArrowBigRight fill="white" />
        </li>
        <Point>{arrTitle}</Point>
      </PointBox>
    </Wrapper>
  );
};

const ArrowLeft = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${palette.opacityBlack80};
  padding: 0.5rem;
  border-radius: 62.5rem;
`;

const Wrapper = styled.div`
  top: 0.625rem;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 20;
`;

const PointBox = styled.ul`
  width: 22.25rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 62.5rem;
  padding: 0.5rem;
  background: ${palette.opacityBlack80};
`;

const Point = styled.li`
  width: min(8.7rem, 100%);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  color: white;
  ${body2};
  font-weight: 700;
`;

export default TopNavigation;
